import React, { useEffect, useState } from "react";
import { ChevronRight } from "@mui/icons-material";
import axios from "axios";
import {
  Grid,
  useTheme,
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Divider,
  useMediaQuery,
  Typography,
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { homeActions } from "actions";
import { connect } from "react-redux";

import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import MessageDialog from "pages/SearchMedication/MessageDialog";
import { authHeader } from "../../helpers";
import { config } from "../../constants";

const settingsList = [
  { title: "Profile", link: "/MyAccount/Profile" },
  { title: "FAQs", link: "/frequently-asked-questions" },
  { title: "Terms and Conditions", link: "/terms-and-conditions" },
  { title: "Privacy Policy", link: "/privacy-policy" },
  { title: "Remove Account", link: "remove" },
  { title: "Contact Us", link: "/contact-us" },
  { title: "Cuverd® Settings", link: "/CuverdSettings" },
  { title: "About Us", link: "/aboutus" },
  { title: "Sign Out", link: "/Signout" },
];

const Settings = (props) => {
  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const { updateGTMDataLayer, gtmInfo } = props;
  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [messageText, setMessageText] = useState(false);
  const [showRespone, setShowRespone] = useState(false);
  const history = useHistory();

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    updateGTMDataLayer({
      page: "Global",
      screen: "Settings",
      screen_title: "Global",
      event: "Nav_settings",
    });
    return () => {
      updateGTMDataLayer({
        screen_referrer: "Settings",
        page: "Global",
        screen: "Settings",
        screen_title: "Global",
        event: "Nav_settings",
      });
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  const deleteAccount = async () => {
    const options = {
      baseURL: config.apiUrl,
      url: `/account/delete`,
      method: "GET",
      headers: authHeader(),
    };
    try {
      const response = await axios(options);
      if (response.status === 200) {
        setMessageText(response?.message);
        setShowRespone(true);
      }
    } catch (error) {
      console.log(error);
      setShowConfirmDialog(false);
    }
  };

  return (
    <SecondaryCenterTemplate pageTitle="Settings">
      <Grid container>
        <Grid item xs={12} sm={8} sx={{ width: "100%", margin: "auto" }}>
          {settingsList.map((listItem) => {
            return (
              <Box key={listItem.title}>
                <List sx={{ paddingBottom: 0, paddingTop: 0 }}>
                  {listItem.link === "remove" ? (
                    <ListItemButton
                      onClick={() => {
                        setShowConfirmDialog(true);
                      }}
                      sx={{ paddingTop: 0, paddingBottom: 0 }}
                    >
                      <ListItemText
                        primary={listItem.title}
                        primaryTypographyProps={{
                          fontSize: "16px",
                          color: theme.palette.primary.main,
                          fontFamily: "Lato-Regular",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      />
                      <ListItemIcon
                        sx={{ minWidth: matchesMinWidth ? 0 : undefined }}
                      >
                        <ChevronRight
                          sx={{ color: theme.palette.common.greenThree }}
                          fontSize="large"
                        />
                      </ListItemIcon>
                    </ListItemButton>
                  ) : (
                    <ListItemButton
                      component={Link}
                      to={listItem.link === "/Signout" ? "/" : listItem.link}
                      onClick={() => {
                        if (listItem.link === "/Signout") {
                          sessionStorage.removeItem("isLoggedIn");
                        }
                      }}
                      sx={{ paddingTop: 0, paddingBottom: 0 }}
                    >
                      <ListItemText
                        primary={listItem.title}
                        primaryTypographyProps={{
                          fontSize: "16px",
                          color: theme.palette.primary.main,
                          fontFamily: "Lato-Regular",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      />
                      <ListItemIcon
                        sx={{ minWidth: matchesMinWidth ? 0 : undefined }}
                      >
                        <ChevronRight
                          sx={{ color: theme.palette.common.greenThree }}
                          fontSize="large"
                        />
                      </ListItemIcon>
                    </ListItemButton>
                  )}
                  <Divider />
                </List>
              </Box>
            );
          })}
          <MessageDialog showPopUp={showConfirmDialog}>
            <Box sx={{ maxWidth: "400px" }}>
              <Typography
                variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
              >
                Are you sure?
              </Typography>
            </Box>
            <Box mt={5}>
              <Button
                variant="large"
                onClick={() => {
                  deleteAccount();
                }}
              >
                OK
              </Button>
            </Box>
            <Box mt={2}>
              <Button
                variant="text"
                onClick={() => {
                  setShowConfirmDialog(false);
                }}
              >
                CANCEL
              </Button>
            </Box>
          </MessageDialog>
          <MessageDialog showPopUp={showRespone}>
            <Box sx={{ maxWidth: "400px" }}>
              <Typography
                variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
              >
                {messageText}
              </Typography>
            </Box>
            <Box mt={5}>
              <Button
                variant="large"
                onClick={() => {
                  setShowRespone(false);
                  sessionStorage.removeItem("isLoggedIn");
                  history.push("/");
                }}
              >
                OK
              </Button>
            </Box>
          </MessageDialog>
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    gtmInfo: state.gtmInfo.data,
  };
};

const mapDispatchToProps = {
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
